import styled from "styled-components";

export default c => styled(c)`
  .user-info--span {
    font-family: "Source Sans Pro", sans-serif;
    padding: 0.25em 0.75em 0.5em;
  }

  .user-info--description {
    font-family: "Source Sans Pro", sans-serif;
    padding: 0.5em;
  }

  .user-info--main {
    font-weight: bold;
  }

  .user-info--icon {
    padding-right: 0.5em;
  }

  .user-info--permission {
    display: inline-flex;
    padding-left: 1.2em;
    align-items: center;
  }

  .user-info--permission:first-child {
    margin-top: 0;
  }

  .user-info--permission-div {
    padding-left: 0.5em;
  }

  .description-field-form {
    padding: 0px;
    margin-bottom: 4px;
  }

  .paper-class {
    margin-top: 4px;
  }

  .allowed-companies {
    max-height: 6.95em;
    overflow-y: auto;
    padding: 8px 0px;
  }

  .div-label-class {
    padding-top: 0.75em;
    padding-right: 1em;
  }

  .label-class {
    width: 100%;
    font-family: Source Sans Pro;
    font-size: 1.1em;
    font-weight: bold;
    color: #222;
  }

  .allowed-companies-col {
    margin: 4px 0px;
  }

  .allowed-companies-slug {
    font-size: 1.025em;
    display: block;
  }

  .allowed-companies-cnpj {
    font-size: 0.9em;
    font-weight: 550;
    color: rgba(0, 0, 0, 0.54);
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/info/style.js